import type React from "react";
import type { SubProject } from "../../utils/mockProjects";
import { useRef } from "react";
import stringToParagraphs from "../../utils/splitPara";

export const Subprojects: React.FC<{
  subProjects: { content: SubProject[]; images: string[] };
}> = ({ subProjects }) => {
  const imgContainerRef = useRef<HTMLDivElement>(null);

  return (
    <div className=" w-full lg:min-h-[80vh] flex flex-col justify-center items-center gap-10 relative py-4 ">
      {subProjects?.content?.map((subProject, index) => {
        return (
          <div
            key={index}
            className="lg:w-1/2 flex flex-col items-center gap-4 justify-center"
          >
            <img src={subProjects.images[index]} className="lg:hidden block py-2 rounded-[20px]" />
            <div className="w-full flex lg:flex-col flex-row lg:items-start items-center gap-4">
              {/* <img
                src={subProject.icon}
                alt={"logo"}
                className={`${
                  index === 0
                    ? "lg:w-[50px] w-[30px]"
                    : index === 1
                    ? "lg:w-[60px] w-[40px]"
                    : "lg:w-[120px] w-[100px]"
                }`}
              /> */}
              <p className="text-primary font-gilroy-bold lg:text-3xl md:text-3xl text-xl">
                {subProject.heading}
              </p>
            </div>
            <div className="text-primary font-gilroy-regular text-justify flex flex-col gap-8 lg:text-xl md:text-lg text-base">
              {stringToParagraphs(subProject.brief)}
            </div>
          </div>
        );
      })}
      <div
        ref={imgContainerRef}
        className="w-screen absolute lg:flex h-full justify-between flex-col hidden"
      >
        {subProjects?.images.map((image, index) => (
          <div
            key={index}
            className={`w-full h-fit flex items-end absolute ${
              index % 2 === 0 ? "justify-start top-0" : "justify-end bottom-0"
            } `}
          >
            <img
              src={image}
              className={`h-[50vh] flex object-contain rounded-[10px]`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
